import * as React from 'react';
import {Component} from 'react';
import classNames from 'classnames';

interface TabProps {
    tabFor: string; // key
    selected: boolean;
    disabled: boolean;
    children: React.ReactChild;
    onSelect(key: string): void;
}

export default class Tab extends Component<TabProps, null> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {onSelect, tabFor, disabled} = this.props;
        !disabled && onSelect(tabFor);
    }

    render() {
        const {selected, disabled, children} = this.props;
        const tabClass = classNames('menu-tab', {
            selected,
            disabled
        });
        return (
            <div className={tabClass} onClick={this.handleClick}>
                {children}
            </div>
        );
    }
}
